export default {
  supportedLngs: ['es', 'cn', 'vi', 'en'],
  browserLanguageDetection: true,
  fallbackLng: 'en',
  lng: 'cimode',
};
